module.exports = __webpack_public_path__ + "static/media/hs129B.a4b4da6f.png";